import React from 'react';
import defaultImage from '../../img/default.png';
import './Profile.css';
const Profile = ({
	teacherId,
	profileClickHandler,
	firstName,
	lastName,
	profileImg,
}) => {
	return (
		<div className="profile-container">
			<img
				src={profileImg || defaultImage}
				alt="Profile"
				title={teacherId}
				className="profile-image"
				onClick={() => profileClickHandler(teacherId)}
			/>
			<div className="teaher-name">
				{firstName} {lastName}
			</div>
		</div>
	);
};

export default Profile;
